// extracted by mini-css-extract-plugin
var _1 = "Xe_5rqXALGn6be7ktwvL";
var _2 = "ZkglUxg3inuf7FnkXyuv";
var _3 = "INANJljUOPDVpw_JS8bg";
var _4 = "Babsu34d9Ko7zCB9iAR0";
export { _1 as "large", _2 as "medium", _3 as "root", _4 as "small" }
export default { "large": _1, "medium": _2, "root": _3, "small": _4 }
